import Line from "components/layout/line";
import { FunctionComponent, useEffect, useState } from "react";
import { useList } from "stores/hooks/list";
import InvitationsTable from "./invitations-table";
import Title from "components/title";
import ScheduledTable from "./scheduled-table";
import { adminDoGetListInvitations } from "services/admin/list-invitation";
import { adminDoGetListSchedules } from "services/admin/list-schedule";
import { ListSchedule } from "models/list-schedule";
import { ListInvitation } from "models/list-invitation";

const InviationsTab: FunctionComponent = () => {
  const [schedules, toggleSchedules] = useState<ListSchedule[]>([]);
  const [invitations, toggleInvitations] = useState<ListInvitation[]>([]);
  const list = useList();

  const update = async () => {
    if (!list) {
      return;
    }

    // update scheduled invitations
    const schedules = await adminDoGetListSchedules(list);
    toggleSchedules(schedules);

    // update email history
    const invitations = await adminDoGetListInvitations(list);
    toggleInvitations(invitations);
  };

  useEffect(() => {
    update();
  }, [list?.uuid]);

  if (!list) {
    return null;
  }

  return (
    <div>
      <Title level="h2">Ajastetut kutsut</Title>
      <ScheduledTable schedules={schedules} list={list} onUpdate={update} />
      <Line />
      <Title level="h2">Lähetyshistoria</Title>
      <InvitationsTable invitations={invitations} listUuid={list.uuid} />
    </div>
  );
};

export default InviationsTab;
